import React, { Component } from 'react';
import { Toast, Form, Input, Button, Modal, Dialog, Space, SpinLoading, } from 'antd-mobile'
import { get, post, url_kh } from '../../utils/http'
import './index.scss';
class BindingCardKaiHe extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            verifyIdName: null,
            cvvName: null,
            cvvNameTwo: null,
            rechargeMoney: null,
            userId: null,
            projectId: null,
            CampusPayInformation: {},
            loginCode: null,
            accountId: null,
            isLoading: true,
            phoneSystem: null,
        }
    }
    componentDidMount() {
        document.title = ""
        let search = window.location.search.slice(1)
        let params = search.split('&')
        var theRequest = new Object()
        for (let i = 0; i < params.length; i++) {
            theRequest[params[i].split("=")[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
        }
        const script = document.createElement('script');
        script.src = 'https://appx/web-view.min.js';
        document.head.appendChild(script);
        this.setState({
            projectId: theRequest.projectId,
            rechargeMoney: theRequest.rechargeMoney,
            userId: theRequest.userId,
            payWay: theRequest.payWay,
            telPhone: theRequest.telPhone,
            loginCode: theRequest.loginCode,
            accountId: theRequest.accountId,
            phoneSystem: theRequest.phoneSystem,
        }, () => {
            this.getCampusPayVerify()
        })
    }
    getCampusPayVerify = () => {
        let params = {
            projectId: this.state.projectId,
            userId: this.state.userId,
            loginCode: this.state.loginCode,
            accountId: this.state.accountId,
        }
        if (this.state.phoneSystem) {
            params.phoneSystem = this.state.phoneSystem;
        }
        get(`${url_kh}/campus/verify/param`, params)
            .then(res => {
                if (res.errorCode == 0) {
                    this.setState({
                        CampusPayInformation: res.data,
                        isLoading: false
                    })
                    document.title = '一卡通绑定'
                    if (window && window?.my) {
                        window.my.postMessage({ 'sendToMiniProgram': document.title });
                    }
                } else {
                    Toast.show({
                        content: res.message,
                        position: 'bottom',
                    })
                    this.setState({
                        isLoading: false
                    })
                }
            })
    }
    onChangeCardBinding = (value) => {
        let { CampusPayInformation, userId, projectId, rechargeMoney, telPhone, loginCode, payWay, accountId, phoneSystem } = this.state
        let { verifyIdName, cvvName, cvvNameTwo } = value
        // let params = {
        //     verificationAccount: verifyIdName,
        //     verificationPassword: cvvName,
        //     verificationPasswordTwo: cvvNameTwo ? cvvNameTwo : '',
        //     userId,
        //     projectId,
        //     loginCode,
        //     accountId,
        //     telPhone,
        //     payWay
        // }
        // if (phoneSystem) {
        //     params.phoneSystem = phoneSystem;
        // }

        const formData = new URLSearchParams();
        formData.append('verificationAccount', verifyIdName);
        formData.append('verificationPassword', cvvName);
        formData.append('verificationPasswordTwo', cvvNameTwo || '');
        // formData.append('userId', userId);
        formData.append('projectId', projectId);
        formData.append('loginCode', loginCode);
        // formData.append('accountId', accountId);
        formData.append('telPhone', telPhone);
        // formData.append('payWay', payWay);
        if (phoneSystem) {
            formData.append('phoneSystem', phoneSystem);
        }
        fetch(`${url_kh}/campus/bind`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData.toString()
        })
            .then(response => response.json())
            .then(res => {
                if (res.errorCode == 0) {
                    Toast.show({
                        content: '绑定成功',
                        position: 'bottom',
                    })
                    setTimeout(() => {
                        this.props.history.push('/rechargeCardKaiHe?rechargeMoney=' + rechargeMoney + '&projectId=' + projectId + '&telPhone=' + telPhone
                            + '&payWay=' + payWay + '&loginCode=' + loginCode + '&accountId=' + accountId + '&phoneSystem=' + phoneSystem)
                    }, 100);
                } else if (res.errorCode == 67) {
                    Toast.show({
                        content: res.message,
                        position: 'bottom',
                    })
                    setTimeout(() => {
                        this.props.history.push('/rechargeCardKaiHe?rechargeMoney=' + rechargeMoney + '&projectId=' + projectId + '&telPhone=' + telPhone
                            + '&payWay=' + payWay + '&loginCode=' + loginCode + '&accountId=' + accountId + '&phoneSystem=' + phoneSystem)
                    }, 1000);
                } else {
                    Toast.show({
                        content: res.message,
                        position: 'bottom',
                    })
                }
            })

    }

    getValid = () => {
        const { CampusPayInformation, verifyIdName, cvvName, cvvNameTwo } = this.state;

        const validations = [];

        if (CampusPayInformation.verifyIdName) {
            validations.push(verifyIdName !== null && verifyIdName !== '' && verifyIdName?.length <= 50);
        }
        if (CampusPayInformation.cvvName) {
            validations.push(cvvName !== null && cvvName !== '' && cvvName?.length <= 50);
        }
        if (CampusPayInformation.cvvNameTwo) {
            validations.push(cvvNameTwo !== null && cvvNameTwo !== '' && cvvNameTwo?.length <= 50);
        }

        return validations.length > 0 && validations.every(valid => valid);
    };

    render() {
        // const onSubmit = (value) => {
        //     Dialog.confirm({
        //         title: "提示",
        //         content: '是否绑定当前账号',
        //         onConfirm: async () => {
        //             await this.onChangeCardBinding(value)
        //             return true
        //         },
        //     })
        // }
        const { CampusPayInformation } = this.state
        const cvvNameBlur = (e) => {
            let value = e.target.value
            this.setState({
                verifyIdName: value
            })

        }
        const verifyIdNameBlur = (e) => {
            let value = e.target.value
            this.setState({
                cvvName: value
            })
        }
        return (
            <>
                {!this.state.isLoading ?
                    <div className="binding-card-page">
                        <Form layout='horizontal'
                            onFinish={this.onChangeCardBinding}
                            footer={
                                <Button block type='submit' color='primary' disabled={!this.getValid()} size='large'> 立即绑定 </Button>

                            }
                        >
                            <Form.Item label={CampusPayInformation.verifyIdName + '：'} name='verifyIdName'>
                                <Input style={{ '--text-align': 'right' }} onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,’’)" onChange={(value) => { this.setState({ verifyIdName: value }) }} placeholder={CampusPayInformation.verifyIdPrompt} clearable />
                            </Form.Item>
                            {
                                CampusPayInformation.cvvName ?
                                    <Form.Item label={CampusPayInformation.cvvName + '：'} name='cvvName'>
                                        <Input style={{ '--text-align': 'right' }} onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,’’)" type='password' onChange={(value) => { this.setState({ cvvName: value }) }} placeholder={CampusPayInformation.cvvPrompt} clearable />
                                    </Form.Item>
                                    : null
                            }
                            {
                                CampusPayInformation.cvvNameTwo ?
                                    <Form.Item label={CampusPayInformation.cvvNameTwo + '：'} name='cvvNameTwo'>
                                        <Input style={{ '--text-align': 'right' }} onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,’’)" onChange={(value) => { this.setState({ cvvName: value }) }} placeholder={CampusPayInformation.cvvPromptTwo} clearable />
                                    </Form.Item>
                                    : null
                            }
                            <Form.Header>
                                <div className="card-recharge-footer">
                                    {CampusPayInformation.remark != null && CampusPayInformation.remark !== '' && <div>
                                        <span className="footer-babel">温馨提示：</span>
                                        <p>{CampusPayInformation.remark}</p>
                                    </div>}
                                </div>
                            </Form.Header>
                            <span></span>
                        </Form>

                    </div>
                    :
                    <div className="page-loading">
                        <Space direction='horizontal' wrap block style={{ '--gap': '16px' }}>
                            <SpinLoading color='primary' />
                        </Space>
                    </div>

                }
            </>
        );
    }
}

export default BindingCardKaiHe;